{
  "GENERAL": {
    "CLOSE": "Zavřít",
    "SHOWING_RESULTS": "Zobrazuji {firstIndex}-{lastIndex} z {totalCount} položek",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Hledat",
      "EMPTY_STATE": "Žádné výsledky"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Musí být alespoň {count}"
  }
}